export default __webpack_public_path__ + "static/media/nossas_unidades_10.ecdf2903.webp";